export enum IntentInitiator {
    Buyer = 'buyer',
}
